import { render, staticRenderFns } from "./accountRecords.vue?vue&type=template&id=3ba980cc&"
import script from "./accountRecords.vue?vue&type=script&lang=js&"
export * from "./accountRecords.vue?vue&type=script&lang=js&"
import style0 from "./accountRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "accountRecords.vue"
export default component.exports